import * as React from "react";
const API_URL =
  process.env.REACT_APP_API_URL || "https://trackency.hubency.com/api";

export function useInviteToken() {
  const qs = new URLSearchParams(window.location.hash.split("?")[1] || "");
  return qs.get("inviteToken") || "";
}

export function useExternalSite() {
  const inviteToken = useInviteToken();
  const [site, setSite] = React.useState<{ id: string; name: string } | null>(
    null
  );
  const [equipments, setEquipments] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const clRes = await fetch(
          `${API_URL}/site-inventory/invite/client?inviteToken=${inviteToken}`
        );
        if (!clRes.ok) throw new Error("Lien invalide");
        const { site: cl } = await clRes.json();
        if (!alive) return;
        setSite({ id: cl._id, name: cl.name });
        setEquipments(cl.equipments || []);
      } catch (e: any) {
        if (!alive) return;
        setError(e.message);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [inviteToken]);

  return { inviteToken, site, equipments, loading, error };
}
